import { AbstractControl, ValidationErrors, ValidatorFn, FormArray } from '@angular/forms';

export const duplicateOptionsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (!(control instanceof FormArray)) {
    return null;
  }

  const optionTexts = control.controls
    .map(ctrl => ctrl.get('text')?.value?.trim())
    .filter(text => text);

  const hasDuplicates = optionTexts.some((item, idx) => optionTexts.indexOf(item) !== idx);

  return hasDuplicates ? { duplicateOptions: true } : null;
};